import { SubscriptionsReportRow } from 'src/graphql/entities/subscriptions-report/subscriptions-report.types';

export function getFullAddress(row: SubscriptionsReportRow) {
  return [row.address1, row.address2].filter(Boolean).join(' ');
}

export function formatReportData(data: SubscriptionsReportRow[]): SubscriptionsReportRow[] {
  const sanitizedData = data.map((d) => ({
    ...d,
    chargeAmount: convertCentsToDollars(d.chargeAmount),
    invoiceSubtotal: convertCentsToDollars(d.invoiceSubtotal),
    latestInvoiceSubtotal: convertCentsToDollars(d.latestInvoiceSubtotal),
    latestInvoiceDiscount: convertCentsToDollars(d.latestInvoiceDiscount),
  }));

  return removeDuplicateRows(sanitizedData);
}

export function removeDuplicateRows(rows: SubscriptionsReportRow[]): SubscriptionsReportRow[] {
  const map = new Map<string, SubscriptionsReportRow>();

  for (const row of rows) {
    if (!map.has(row.subscriptionId)) {
      map.set(row.subscriptionId, row);
    }
  }

  return Array.from(map.values());
}

function convertCentsToDollars(cents?: number | null): number {
  if (cents === undefined || cents === null) {
    return 0;
  }

  return cents / 100;
}
